
const accordion = document.querySelector('.faq__question-list');

if (accordion) {
  const navButtons = document.querySelectorAll('.faq__nav-button');
  const filters = document.querySelectorAll('.faq__filter-button');
  const accourdionItems = document.querySelectorAll('.faq__question');
  
  navButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      navButtons.forEach((button) => {
				button.classList.remove('active');
      });
      
      e.currentTarget.classList.add('active');

      accourdionItems.forEach(item => {
        if (item.dataset.type == e.currentTarget.id) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      })

      filters.forEach((filter) => {
				if (filter.id.includes(e.currentTarget.id)) {
					filter.style.display = 'block';
				} else {
					filter.style.display = 'none';
				}
			});
    })
  })

	// filterButtons.forEach((button) => {
	// 	button.addEventListener('click', (e) => {
	// 		filterButtons.forEach((button) => {
	// 			button.classList.remove('active');
	// 		});

	// 		e.currentTarget.classList.add('active');

	// 		groups.forEach((group) => {
	// 			if (group.id !== e.currentTarget.dataset.id) {
	// 				group.style.display = 'none';
	// 			} else {
	// 				group.style.display = 'block';
	// 			}
	// 		});
	// 	});
	// });
}
